import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function GoogleFailed() {
  const navigate = useNavigate();

  useEffect(() => {
    // Fix double slash issue in URL
    const pathname = window.location.pathname;
    if (pathname.includes("//")) {
      const normalizedPath = pathname.replace(/\/\//g, "/");
      window.history.replaceState(
        null,
        "",
        normalizedPath + window.location.search + window.location.hash
      );
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <p className="text-2xl font-bold">google sso login failed</p>
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-md"
        onClick={() => navigate("/login")}
      >
        login
      </button>
    </div>
  );
}
